import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Posts = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const listRes = await fetch(`${process.env.PUBLIC_URL}/postList.json`);
        const data = await listRes.json();
        const slugs = (data.newPosts || []).map(file => file.replace('.md', ''));
        setPosts(slugs);
      } catch (error) {
        console.error('Error fetching posts:', error);
      }
    };
    fetchPosts();
  }, []);

  return (
    <div className="posts-list">
      <ul>
        {posts.map(slug => (
          <li key={slug}>
            <Link to={`/reading/${slug}`}>{slug}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Posts;
